import Button from "@components/Button";
import Link from "@components/Link";
import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import cx from "classnames";
import React from "react";
import styles from "./Experiencing.module.scss";
// import { useRouteContext } from "@providers/RouteProvider";
import _ from "lodash";
interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    } | null;
    title: string;
    content: string | React.ReactNode;
    readMoreButton?: {
      label: string | React.ReactNode;
      href: string;
      type: string;
    } | null;
    actionMore?: string | React.ReactNode;
    link?: string;
    queryParams?: { [key: string]: string };
  };

  className: string | { [key: string]: string };
}

export default function Item({ data, className }: Props) {
  // const { router } = useRouteContext();
  const readMoreButton: any = _.get(data, "readMoreButton");
  return (
    <div className={cx("slide-item animated", styles.item, className)}>
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={data?.image?.src}
        alt={data?.image?.alt}
        layout="fill"
        objectFit="cover"
      />
      <ClipText fixedRows rows={2} className={cx(styles.title)}>
        {data.title}
      </ClipText>
      <ClipText fixedRows rows={3} className={cx(styles.content)}>
        {data.content}
      </ClipText>
      <Link href={_.get(readMoreButton, "href")}>
        <Button
          type="icon"
          suffix="shape-arrow"
          className={cx(styles.actionMore)}
          label={_.get(readMoreButton, "label")}
          // onClick={() => router.push(data?.link, data?.queryParams ?? {})}
        />
      </Link>
    </div>
  );
}
